import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { SquirrelTabs, USERTABS } from 'projects/shared/src/lib/models/SquirrelTabs';
import { UserDto, UserResolved } from 'projects/shared/src/lib/models/User';
import { UserProfileForCreation } from 'projects/shared/src/lib/models/UserProfileForCreation';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'edit-user-profile',
  templateUrl: './edit-user-profile.component.html',
  styleUrls: ['./edit-user-profile.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class EditUserProfileComponent implements OnInit {
  userDto!: UserDto;
  tabs: SquirrelTabs[] = [];

  //admin$!: Observable<string>;
  admin!: string;
  showTenantGrpRoles: boolean = true;

  constructor(private route: ActivatedRoute,
    private oauthService: OAuthServiceService,
    private tenantService: TenantService,
    private userProfileService: UserProfileService,
    public translate: TranslateService) { }

  ngOnInit(): void {

    this.showTenantGrpRoles = this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation;
    this.tabs = USERTABS;
    this.route.data.subscribe((data: any) => {
      const resolvedData: UserResolved = data['resolvedData'];
      this.userDto = resolvedData.userDto;

      console.log("============== getUserById =============")
      this.userProfileService.getUserById(this.userDto.id).subscribe({
        next:(userProfile: UserProfileForCreation) => {       
          //(userProfile.fullName) ? this.userDto.userName = userProfile.fullName : this.userDto.userName = userProfile.username;
          if (userProfile.familyName != null)
            this.userDto.userName = userProfile.givenName + " " + userProfile.familyName;
          this.userDto.first_Name = userProfile.givenName;
          this.userDto.last_Name = userProfile.familyName;
          this.userDto.phoneNumber = userProfile.phoneNumber;

          // this.userData.push(user);
          // console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
          // if (count == users.length) {
          //   console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
          //   this.rowData = this.userData.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));
          //   //this.rowData = this.userData.sort();
          //   //this.rowData = this.userData;
          //   this.rowData = this.rowData.slice(params.startRow, params.endRow);
          //   let lastRow = -1;

          //   if (users.length <= params.endRow) {
          //     lastRow = users.length;
          //   }
          //   params.successCallback(this.rowData, lastRow);
          //   this.isLoadingResults = false;
          //   this.isRateLimitReached = false;
          //   this.resultsLength = this.rowData.length;

          //   this.gridApi.hideOverlay();
          
          }
      });


    },
      // error
    );

    this.oauthService.userData.subscribe({
      next: (data) => {
        data.role.forEach((r: string) => {
          if (r === 'admin') {
            this.admin = r;
          }
        });
      }
    });
  }
}
